import React from 'react';
import { Card, BlockStack, Text, ChoiceList, TextField } from '@shopify/polaris';

export function OrdersTaxSection({ value, onChange, bare = false }) {
  const update = (field, newValue) => onChange({ ...value, [field]: newValue });

  // Map order shape fields to tax section fields
  const taxModeOption = value.taxMode || 'legacy';
  const netSuiteTaxCode = value.taxCode || '';

  const content = (
    <BlockStack gap="loose">
      <div>
        <Text variant="headingMd" fontWeight="bold" as="h3">Tax Settings</Text>
      </div>

      <ChoiceList
        choices={[
          {
            label: 'NetSuite Legacy Tax',
            value: 'legacy',
            helpText: 'Use one blended transaction-level tax rate from the source tax total.'
          },
          {
            label: 'NetSuite SuiteTax',
            value: 'suiteTax',
            helpText: 'Send source tax details for SuiteTax tax detail override.'
          },
          {
            label: 'Third-party tax engine',
            value: 'external',
            helpText: 'Do not pass source tax; let the NetSuite tax engine calculate tax.'
          },
          {
            label: 'Zero tax / non-taxable order',
            value: 'zeroTax',
            helpText: 'Force the order and item lines to use the configured non-taxable tax code with $0 tax.'
          }
        ]}
        selected={[taxModeOption]}
        onChange={(selected) => {
          const opt = selected[0];
          // Map selected tax mode back to the order settings shape.
          update('taxMode', opt);
        }}
      />

      {(taxModeOption === 'legacy' || taxModeOption === 'suiteTax' || taxModeOption === 'zeroTax') && (
        <TextField
          label="NetSuite Tax Code / Item (Internal ID)"
          value={netSuiteTaxCode}
          onChange={(v) => update('taxCode', v)}
          placeholder="Enter NetSuite tax code or item"
        />
      )}
    </BlockStack>
  );

  return bare ? content : (
    <Card sectioned>
      {content}
    </Card>
  );
}
